module.exports = __webpack_public_path__ + "img/pkw.4285216a.jpg";